import React from "react";
import {connect} from "react-redux";
import Kontakt from "../components/Kontakt";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

class KontaktContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshPageController: false
        }
    }

    render() {
        return (
            <div>
                <Kontakt />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(KontaktContainer);


// WEBPACK FOOTER //
// ./src/container/KontaktContainer.js